// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FrCL","toggleWrap":"styles_toggleWrap__38s5j","content":"styles_content__2xFR-","selectAreaCode":"styles_selectAreaCode__5RWDG"};